<template>
  <b-card class="transport-summary" no-body role="tablist">
    <b-card-header class="transport-summary-header" header-tag="header">
      Other Information
    </b-card-header>
    <b-card-body class="transport-summary-content" v-for="(section, sectName, index) in infoSections" :key="sectName">
      <b-card class="transport-summary-section" no-body>
        <b-card-header header-tag="section" role="tab">
          <b-button class="btn-collapse" block variant="light" v-b-toggle="`transport-summary-collapse-${index}`">
            {{ sectName }}
          </b-button>
        </b-card-header>
        <b-collapse :id="`transport-summary-collapse-${index}`" :visible="index === 0" role="tabpanel">
          <b-card-body>
            <div class="row mb-2 pb-0" v-for="(item, key) in section" :key="key">
              <b-card-text class="col text-left font-weight-bold">{{ key }}</b-card-text>
              <b-card-text class="col text-right">{{ normalizeValue(item) }}</b-card-text>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'AppTransportSummary',
  props: {
    infoSections: { type: Object }
  },

  methods: {
    normalizeValue(item) {
      if (!item.value) return 'N/A';
      if (item.type === 'date') {
        // TODO: Fix deprecation warnnig from moment.js
        return this.$moment(item.value).format('YYYY-MM-DD');
      }
      if (item.type === 'time') {
        return this.$moment(item.value, 'HH:mm:ss').format('h:mm:ss A');
      }

      return item.value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/custom.scss';
.card {
  border: none;
}

.transport-summary.card {
  border-radius: 3px;
  box-shadow: 0px 2px 4px 0px rgba(32, 32, 32, 0.5);
  overflow: hidden;
  border: none;
}

.transport-summary.card .transport-summary-header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  border-bottom: none;
  background-color: var(--color-dark);
  color: white;
  font-size: 30px;
}

.transport-summary.card .transport-summary-content {
  padding: 0;
}

.transport-summary-section .card-header {
  border-radius: 0;
  padding: 0;
  border: none;
  box-shadow: 0px 1px 3px 0px rgba(32, 32, 32, 0.5);
  overflow: hidden;
}

.transport-summary-section .btn.btn-collapse {
  border: none;
  border-radius: 0;
  padding: 0.75rem 1rem;
  background-color: #f8aa50;
  color: black;
  text-transform: capitalize;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
}
</style>
